import { format, parseISO } from 'date-fns';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { styled } from 'styled-components';
import { CoinType } from '../../@types/aboutfishing';
import { postSupportCoin } from '../../api/login';
import CoinModalCenter from '../../components/myshopping/CoinModalCenter';
import CoinModalFull from '../../components/myshopping/CoinModalFull';
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar';
import { useCommonContext } from '../../components/provider/CommonProvider';
import { PageTitle } from '../../components/title/PageTitle';
import { plusComma } from '../../js/script';
import { imgURL } from '../Home';

type TabType = {
  label: string;
  type: string;
};

export default function CoinDetail() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [items, setItems] = useState<CoinType[]>([]);
  const [type, setType] = useState<string>('total');
  const tab: TabType[] = [
    { label: '전체', type: 'total' },
    { label: '적립', type: 'plus' },
    { label: '취소', type: 'cancel' },
    { label: '차감', type: 'minus' },
  ];
  const [expectedCoin, setExpectedCoin] = useState<number>(0);
  const [coin, setCoin] = useState<number>();
  const [coinModal, setCoinModal] = useState<boolean>(false);
  const { hasAccessToken } = useCommonContext();

  const typeMsg: { [key: string]: string } = {
    total: '전체',
    plus: '적립',
    cancel: '취소',
    minus: '차감',
  };

  const message = typeMsg[type];

  useEffect(() => {
    const fetchData = async () => {
      if (hasAccessToken) {
        setIsLoading(true);
        try {
          const res = await postSupportCoin(type);
          setItems(res.data.result);
          setCoin(res.data.totalCoin);
          setExpectedCoin(res.data.expectedCoin);
        } catch (err) {
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [type]);

  useEffect(() => {}, []);

  return (
    <>
      <div className="main_wrap">
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className="myshopping_wrap">
            <PageTitle>피싱코인 내역</PageTitle>
            <CoinWrap>
              <div className="coin_cont">
                <button
                  type="button"
                  onClick={() => {
                    setCoinModal(true);
                  }}
                >
                  <img src="../../images/icon_information.png" />
                </button>
                <div className="inner_box">
                  {coin ? <p>{plusComma(coin)}</p> : <LoadingCoin>코인내역을 조회중입니다.</LoadingCoin>}
                  <span>적립예정 : {expectedCoin} Coin</span>
                </div>
              </div>
            </CoinWrap>

            <TabWrap>
              {tab.map((el: any, index: number) => (
                <Tab
                  key={index} // key prop 추가
                  className={type === el.type ? 'on' : ''}
                  onClick={() => {
                    setType(el.type);
                  }}
                >
                  {el.label}
                </Tab>
              ))}
            </TabWrap>

            <CoinList>
              {isLoading ? (
                <Loading>조회중입니다..</Loading>
              ) : items.length !== 0 ? (
                <div className="list_wrap">
                  <div className="tit">
                    <dl>
                      <dt>내역</dt>
                      <dd>적립금</dd>
                    </dl>
                  </div>
                  <div className="list">
                    {items.map((el: any) => (
                      <CoinDetailList key={el.id} el={el}></CoinDetailList>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="no_data">
                  <img src={`${imgURL}/empty_logo.png`} alt="" />
                  <p>피싱코인 {`${message}`} 내역이 없습니다.</p>
                </div>
              )}
            </CoinList>
          </div>
        </div>
      </div>
      {coinModal &&
        (isMobile ? <CoinModalFull setIsModal={setCoinModal} /> : <CoinModalCenter setIsModal={setCoinModal} />)}
    </>
  );
}

function CoinDetailList({ el }: any) {
  const [time, setTime] = useState<string>();

  useEffect(() => {
    if (el) {
      const utcDate = parseISO(el.createdAt);
      const dateTimeString = format(utcDate, 'yyyy. MM. dd. HH:mm');
      setTime(dateTimeString);
    }
  }, [el]);

  const isSave = el.typeName === '적립' || el.typeName === '차감취소';
  const formattedTime = time?.substring(0, 12).replaceAll('. 0', '. ');

  return (
    <dl className={isSave ? 'save' : ''}>
      <dt>
        <span>{formattedTime}</span>
        <p>{el.note}</p>
      </dt>
      <dd>
        <p>{`${isSave ? '+' : '-'}${plusComma(Math.abs(el.coin))}`}</p>
        <span>{el.typeName}</span>
      </dd>
    </dl>
  );
}

export const CoinList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: flex-start;
  & .no_data {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 80px 0 100px 0;
  }
  & .no_data > img {
    width: 85px;
    height: 85px;
    margin-bottom: 8px;
  }
  & .no_data > p {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: var(--colGray5);
  }
  & .list_wrap {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px 20px 48px 20px;
    & .tit {
      & dl {
        display: flex;
        justify-content: space-between;
        align-items: center;
        & dt {
          font-size: 15px;
          line-height: 18px;
          color: var(--colBlack);
          font-weight: 600;
        }
        & dd {
          font-size: 15px;
          line-height: 18px;
          color: var(--colBlack);
          font-weight: 600;
        }
      }
    }
    @media screen and (min-width: 768px) {
      padding: 24px 0 48px 0;
    }
  }

  & .list {
    display: flex;
    flex-direction: column;
    flex: 1;
    & dl {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid var(--colGray2);
      &:last-child {
        border: 0;
      }
      & dt {
        & span {
          display: block;
          font-size: 13px;
          line-height: 16px;
          color: var(--colGray6);
          margin-bottom: 5px;
        }
        & p {
          font-size: 14px;
          line-height: 18px;
          color: var(--colBlack);
        }
      }

      & dd {
        text-align: right;
        & p {
          font-size: 14px;
          line-height: 18px;
          color: #ff1717;
          font-weight: 600;
          margin-bottom: 3px;
        }
        & span {
          display: inline-block;
          font-size: 11px;
          font-weight: 500;
          line-height: 12px;
          padding: 3px 8px;
          background: var(--colGray2);
          border-radius: 9px;
        }
      }
      &.save {
        & dd {
          & p {
            color: #0000ff;
          }
        }
      }
    }
  }
  @media screen and (min-width: 768px) {
    & .no_data > img {
      width: 108px;
      height: 108px;
      margin-bottom: 0;
    }
    & .no_data > p {
      font-size: 20px;
      font-weight: 500;
      line-height: 32px;
      color: var(--colGray5);
    }
  }
`;

export const CoinWrap = styled.div`
  padding: 8px 20px 18px 20px;
  & .coin_cont {
    position: relative;
    background: var(--colGray1);
    border-radius: 12px;
    padding: 10px;
    text-align: center;

    & button {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      padding: 0;
      margin: 0;
      border: 0;
      background: transparent;
      & img {
        width: 100%;
      }
    }
    & div {
      padding: 28px 0;
      & p {
        display: inline-block;
        font-size: 26px;
        line-height: 32px;
        color: var(--colBlack);
        font-weight: 500;
        position: relative;
        padding-right: 20px;
        &:after {
          content: '';
          width: 16px;
          height: 16px;
          background: url('../../images/icon_coin.png') no-repeat;
          background-size: contain;
          position: absolute;
          top: 8px;
          right: 0;
        }
      }
      & span {
        display: block;
        font-size: 13px;
        line-height: 16px;
        color: var(--colGray6);
        margin-top: 5px;
      }
    }
  }
  @media screen and (min-width: 768px) {
    padding: 32px 0 24px 0;
  }
`;

// 탭 Wrap
export const TabWrap = styled.div`
  width: 100%;
  display: flex;
  height: 48px;
  @media screen and (min-width: 768px) {
    gap: 20px;
    height: 50px;
    border-bottom: 1px var(--colGray3) solid;
  }
`;
// 상품 상세정보, 리뷰 탭
export const Tab = styled.div`
  flex: 1;
  padding: 15px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colGray5);
  background: var(--colWhite);
  border-bottom: 1px var(--colGray3) solid;
  cursor: pointer;
  & span {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: var(--colPointBlue);
    margin-left: 3px;
  }
  &.on {
    color: var(--colBlack);
    border-bottom: 1px var(--colBlack) solid;
  }
  @media screen and (min-width: 768px) {
    flex: none;
    padding: 0 2px;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--colGray5);
    background: var(--colWhite);
    border-bottom: none;
    cursor: pointer;
    & span {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: var(--colPointBlue);
      margin-left: 3px;
    }
    &.on {
      position: relative;
      top: 1px;
      font-weight: 700;
      color: var(--colBlack);
      border-bottom: 2px var(--colBlack) solid;
    }
  }
`;

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  font-size: 16px;
`;

export const LoadingCoin = styled.span`
  font-size: 16px;
  color: #000;
  line-height: 32px;
  display: block;
`;
